import React from 'react'
import undefsafe from 'undefsafe'
import raf from 'raf'

import ItemActions from './common/itemActions'
import TrendingItem from './common/trendingItem'

import styles from './gridVideo.module.css'

class ItemCardGridVideo extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      playing: false,
      hideCursor: false,
      videoPlayPromise: null,
      videoLooped: false,
      reportedEvents: []
    }

    this.onMouseOver = this.onMouseOver.bind(this)
    this.onMouseOut = this.onMouseOut.bind(this)

    this.onMouseOverVideo = this.onMouseOverVideo.bind(this)
    this.onMouseOutVideo = this.onMouseOutVideo.bind(this)
    this.onMouseMoveVideo = this.onMouseMoveVideo.bind(this)

    this.setVideoElementRef = this.setVideoElementRef.bind(this)
    this.onVideoProgress = this.onVideoProgress.bind(this)
  }

  setVideoElementRef (element) {
    this.videoElement = element
  }

  onMouseMoveVideo () {
    if (this.state.hideCursor) {
      this.setState({ hideCursor: false })
      this.onMouseOverVideo()
    }
  }

  onMouseOverVideo () {
    this.timeout = setTimeout(() => {
      this.setState({ hideCursor: true })
    }, 3000)
  }

  onMouseOutVideo () {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    this.setState({ hideCursor: false })
  }

  onVideoProgress () {
    if (this.state.playing) {
      const playProgress = Math.floor(this.videoElement.currentTime / this.videoElement.duration * 100)
      this.handleVideoReportEvent(playProgress)
      raf(this.onVideoProgress)
    }
  }

  handleVideoReportEvent (playProgress) {
    if (this.videoElement.currentTime === 0) {
      this.reportEvent('video_start')
    }

    if (playProgress >= 25 && playProgress < 50) {
      this.reportEvent('25_percent')
    }

    if (playProgress >= 50 && playProgress < 75) {
      this.reportEvent('50_percent')
    }

    if (playProgress >= 75) {
      this.reportEvent('75_percent')
    }

    if (playProgress + 1 >= 100) {
      this.reportEvent('video_complete')
      this.setState({
        videoLooped: true
      })
    }
  }

  hasEventReported (eventName) {
    return this.state.reportedEvents.indexOf(eventName) >= 0
  }

  reportEvent (eventName) {
    if (!this.state.videoLooped && !this.hasEventReported(eventName)) {
      const { item } = this.props
      const videoSrc = undefsafe(item, 'previews.icon_with_video_preview.video_url')

      if (this.props.reportVideoProgress) {
        this.props.reportVideoProgress(eventName, videoSrc)
        this.setState({
          reportedEvents: [eventName, ...this.state.reportedEvents]
        })
      }
    }
  }

  onMouseOver () {
    if (this.videoElement && this.videoElement.paused) {
      this.setState({
        videoPlayPromise: this.videoElement.play().then(() => {
          this.setState({ playing: true }, () => {
            this.onVideoProgress()
          })
        })
      })
    }
  }

  onMouseOut () {
    const { videoPlayPromise } = this.state
    if (this.videoElement && !this.videoElement.paused) {
      if (videoPlayPromise) {
        videoPlayPromise.then(() => {
          this.videoElement.pause()
          this.setState({ playing: false })
        })
      }
    }
  }

  render () {
    const { item, onAddToFavourites, rank, onAddToCollections, onItemLinkClick, onAddToCart, muted } = this.props

    let videoLinkStyle
    let overlayStyle

    if (this.state.hideCursor) {
      videoLinkStyle = { cursor: 'none' }
      overlayStyle = { opacity: 0 }
    }

    const videoLength = undefsafe(item.attributes.find(attribute => attribute.name === 'length-video'), 'value')
    const videoUrl = undefsafe(item, 'previews.icon_with_video_preview.video_url')
    const posterUrl = undefsafe(item, 'previews.icon_with_video_preview.landscape_url')

    return (
      <div className={styles.container}>
        {item.trending && <TrendingItem />}
        <div className={styles.videoContainer} onMouseOver={this.onMouseOver} onMouseOut={this.onMouseOut}>
          <a href={`${item.url}?s_rank=${rank}`} onClick={onItemLinkClick} style={videoLinkStyle}>
            <video
              muted={muted}
              onMouseOver={this.onMouseOverVideo}
              onMouseOut={this.onMouseOutVideo}
              onMouseMove={this.onMouseMoveVideo}
              ref={this.setVideoElementRef}
              className={styles.video}
              loop
              src={videoUrl}
              poster={posterUrl} />
          </a>
          <div className={styles.overlay} style={overlayStyle}>
            <div className={styles.itemActions}>
              <ItemActions
                item={item}
                defaultTheme={false}
                onAddToFavourites={onAddToFavourites}
                onAddToCollections={onAddToCollections}
                onAddToCart={onAddToCart} />
            </div>
            <div className={styles.price}>${item.price}</div>
          </div>
        </div>
        <div className={styles.meta}>
          <div className={styles.titleContainer}>
            <a className={styles.title} href={`${item.url}?s_rank=${rank}`} onClick={onItemLinkClick}>{item.name}</a>
          </div>
          <div className={styles.duration}>{videoLength}</div>
        </div>
      </div>
    )
  }
}

export default ItemCardGridVideo



// WEBPACK FOOTER //
// ./client/components/itemCard/gridVideo.js